




export const createNewSkill = async (functionParameters = {}) => {

    let { smartboxStorageName = "creatSkillsSmartboxes", modelPath = "loggedInUser/skills/treatmentsSkillsModel"} = functionParameters;
    

    const { retrieveModel } = (await import(/* webpackPrefetch: true */ "../general/retrieveModel"));

    functionParameters["smartboxStorageName"] = smartboxStorageName;
    functionParameters["modelPath"] = modelPath;
    functionParameters["submissionFuncPath"] = "apps/skills/updatePartsOfSkills";
    functionParameters["sideMenuToUse"] = "skills";
    
    return await retrieveModel(functionParameters);


    // const smartboxStorageName = "creatSkillsSmartboxes";

    // if (smartboxStorageName in window) {

    //     const { idOfcurrentlyVisibleSmartBox } = window[smartboxStorageName];
    //     window[smartboxStorageName]["smartboxes"][idOfcurrentlyVisibleSmartBox].animate({ animation: "shakeX" });

    //     return false;
    // };


    // const { token, copyApiEndPoint, isCopying, treatmentName, submitText, instructionTitle, } = functionParameters;

    // const appClass = window.smetioApp;

    // const apiEndPoint = window.apiEndPoint;
    // const language = window.userLanguage;

    // const axios = (await import(/* webpackPrefetch: true */ "axios")).default;
    // // const generateId = (await import(/* webpackPrefetch: true */ `../../../classes/universal_methods/generateId.js`)).generateId;
    // const displayAndStoreSmartboxWithPreloader = (await import(/* webpackPrefetch: true */ "../../display/displayAndStoreSmartboxWithPreloader.js")).displayAndStoreSmartboxWithPreloader;

    // const smartBoxTitle = isCopying == true ? "txt1331" : treatmentName || "txt1331";
    // const { preloader, smetioSmartbox, backBtnIsClicked } = await displayAndStoreSmartboxWithPreloader({ title: smartBoxTitle, smartboxStorageName });

    // const url = copyApiEndPoint ? copyApiEndPoint : `${apiEndPoint}/apps/${appClass.appUserInterface}/skills/model/${language}`;

    // const modelPath = "loggedInUser/skills/treatmentsSkillsModel";

    // const res = await axios.get(url, { params: { token, modelPath, isCopying } }).then(async (response) => {

    //     let model = response.data;

    //     if (model.error) {
    //         backBtnIsClicked();
    //         return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: model.msg }] });
    //     };

    //     const { nextStep, modelPath, instructionTitle, instructionSubtitle, token, treatmentName, updateCompleted } = model;
    //     model = model.model;


    //     const setTxtV2 = (await import(/* webpackPrefetch: true */ "./../../../classes/universal_methods/setTxtV2.js")).setTxtV2;

    //     const newVersionOfConvertModelToInputs = (await import(/* webpackPrefetch: true */ "./../../../classes/universal_methods/newVersionOfConvertModelToInputs.js")).newVersionOfConvertModelToInputs;

    //     const markedFieldText = setTxtV2({ attributes: {}, txt: "txt56", type: "html" });

    //     const url = `${apiEndPoint}/apps/${appClass.appUserInterface}/skills/create/${language}`;

    //     const confirmationInput = await newVersionOfConvertModelToInputs({
    //         model,
    //         withSubmitButton: true,
    //         withFullContainerDiv: true,
    //         submitText: "txt38",
    //         doNotShowInstruction: true,
    //         instructionTitle: "",
    //         instructionSubtitle: "",
    //         submissionFunctionDetails: {
    //             functionPath: "apps/treatments/bodyPartsOptionsModel",
    //             functionParameters: { appClass, preloader, smetioSmartbox, token, smartboxStorageName, treatmentName, isCopying, url, modelPath, sideMenuToUse:"skills" },
    //             // addToSubmissionData: isCopying == true ? {} : {token}
    //             addToSubmissionData: { token, isCopying, treatmentName }
    //         },
    //         //   showBackBtn:true,
    //         //   onBackBtnClicked: ()=>{
    //         //     window["whatBodyPartModelSmartbox"].hide();
    //         //     window["whoIsTreatmentForModelSmartbox"].show();
    //         //   },           

    //     });

    //     const newPreloaderDisplay = preloader.render();

    //     const content = `
    //       ${newPreloaderDisplay}
    //       ${confirmationInput}
    //     `;
    //     preloader.hide();

    //     smetioSmartbox.updateContent(content);

    // }).catch((error) => {

    //     console.log(error);
    //     return window.smetioVisitor.showNotification({ type: "danger", body: [{ message: "txt423" }] });

    // }).finally(() => {
    //     preloader.hide();
    // });
};
